export enum UserOrgSettingsMenuType {
    ORGANIZATION = "ORGANIZATION",
    ORGANIZATION_MEMBERS_MANAGEMENT = "ORGANIZATION_MEMBERS_MANAGEMENT",
    PAYMENT = "PAYMENT",
    CreditManagement = "CreditManagement",
}
